// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scenes page styles */
.scenes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 15px;
}

.scene-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #5865f2;
  transition: transform 0.2s ease;
}

.scene-card:hover {
  transform: translateY(-2px);
}

.scene-card.active {
  border-left-color: #43b581;
}

.scene-card.completed {
  border-left-color: #faa61a;
  opacity: 0.9;
}

.scene-card.archived {
  border-left-color: #72767d;
  opacity: 0.7;
}

.scene-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.type-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
}

.type-badge.rp { background: #5865f2; color: white; }
.type-badge.erp { background: #eb459e; color: white; }
.type-badge.combat { background: #f04747; color: white; }
.type-badge.social { background: #43b581; color: white; }
.type-badge.event { background: #faa61a; color: black; }

.status-badge.planned { background: #5865f2; color: white; }
.status-badge.active { background: #43b581; color: white; }
.status-badge.completed { background: #faa61a; color: black; }
.status-badge.archived { background: #72767d; color: white; }

.scene-title {
  color: #fff;
  margin: 0 0 8px 0;
  font-size: 16px;
}

.scene-desc {
  color: #b9bbbe;
  font-size: 13px;
  margin: 0 0 10px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.scene-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.meta-item {
  font-size: 12px;
  background: #202225;
  padding: 2px 8px;
  border-radius: 4px;
  color: #b9bbbe;
}

.meta-item.setting {
  color: #43b581;
}

.meta-item.characters {
  color: #5865f2;
}

.meta-item.date {
  color: #faa61a;
}

.meta-item.rating {
  color: #eb459e;
  font-weight: bold;
}

.scene-summary {
  color: #72767d;
  font-size: 12px;
  margin: 0 0 10px 0;
  font-style: italic;
  padding: 8px;
  background: #202225;
  border-radius: 4px;
}

.scene-actions {
  display: flex;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #40444b;
}

.action-btn.start {
  background: #43b581;
  color: white;
}

.action-btn.note {
  background: #5865f2;
  color: white;
}

.action-btn.end {
  background: #faa61a;
  color: black;
}

.action-btn.archive {
  background: #72767d;
  color: white;
}

.modal-subtitle {
  color: #b9bbbe;
  font-size: 13px;
  margin: -10px 0 15px 0;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: #40444b;
  outline: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5865f2;
  cursor: pointer;
  border: none;
}

.no-data {
  text-align: center;
  color: #72767d;
  padding: 40px;
  grid-column: 1 / -1;
}

/* Shared styles */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filter-tabs button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.filter-tabs button.active,
.filter-tabs button:hover {
  background: #5865f2;
  color: white;
}

.status-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
}

.action-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.action-btn.delete {
  background: #f04747;
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Scenes.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;AACpD,kBAAkB,mBAAmB,EAAE,YAAY,EAAE;AACrD,qBAAqB,mBAAmB,EAAE,YAAY,EAAE;AACxD,qBAAqB,mBAAmB,EAAE,YAAY,EAAE;AACxD,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;;AAEvD,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,0BAA0B,mBAAmB,EAAE,YAAY,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,YAAY,EAAE;;AAE5D;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Scenes page styles */\n.scenes-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 15px;\n}\n\n.scene-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  border-left: 4px solid #5865f2;\n  transition: transform 0.2s ease;\n}\n\n.scene-card:hover {\n  transform: translateY(-2px);\n}\n\n.scene-card.active {\n  border-left-color: #43b581;\n}\n\n.scene-card.completed {\n  border-left-color: #faa61a;\n  opacity: 0.9;\n}\n\n.scene-card.archived {\n  border-left-color: #72767d;\n  opacity: 0.7;\n}\n\n.scene-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.type-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.type-badge.rp { background: #5865f2; color: white; }\n.type-badge.erp { background: #eb459e; color: white; }\n.type-badge.combat { background: #f04747; color: white; }\n.type-badge.social { background: #43b581; color: white; }\n.type-badge.event { background: #faa61a; color: black; }\n\n.status-badge.planned { background: #5865f2; color: white; }\n.status-badge.active { background: #43b581; color: white; }\n.status-badge.completed { background: #faa61a; color: black; }\n.status-badge.archived { background: #72767d; color: white; }\n\n.scene-title {\n  color: #fff;\n  margin: 0 0 8px 0;\n  font-size: 16px;\n}\n\n.scene-desc {\n  color: #b9bbbe;\n  font-size: 13px;\n  margin: 0 0 10px 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.scene-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.meta-item {\n  font-size: 12px;\n  background: #202225;\n  padding: 2px 8px;\n  border-radius: 4px;\n  color: #b9bbbe;\n}\n\n.meta-item.setting {\n  color: #43b581;\n}\n\n.meta-item.characters {\n  color: #5865f2;\n}\n\n.meta-item.date {\n  color: #faa61a;\n}\n\n.meta-item.rating {\n  color: #eb459e;\n  font-weight: bold;\n}\n\n.scene-summary {\n  color: #72767d;\n  font-size: 12px;\n  margin: 0 0 10px 0;\n  font-style: italic;\n  padding: 8px;\n  background: #202225;\n  border-radius: 4px;\n}\n\n.scene-actions {\n  display: flex;\n  gap: 8px;\n  padding-top: 10px;\n  border-top: 1px solid #40444b;\n}\n\n.action-btn.start {\n  background: #43b581;\n  color: white;\n}\n\n.action-btn.note {\n  background: #5865f2;\n  color: white;\n}\n\n.action-btn.end {\n  background: #faa61a;\n  color: black;\n}\n\n.action-btn.archive {\n  background: #72767d;\n  color: white;\n}\n\n.modal-subtitle {\n  color: #b9bbbe;\n  font-size: 13px;\n  margin: -10px 0 15px 0;\n}\n\n.slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 8px;\n  border-radius: 4px;\n  background: #40444b;\n  outline: none;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #5865f2;\n  cursor: pointer;\n  border: none;\n}\n\n.no-data {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n  grid-column: 1 / -1;\n}\n\n/* Shared styles */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.filter-tabs button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.filter-tabs button.active,\n.filter-tabs button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n.status-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n.action-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n\n.action-btn.delete {\n  background: #f04747;\n  color: white;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
